<template>

    <tabs-main
        class="p-add_patient__tabs"
        :validator="$validator"
        @submit="submit"
        @submit-error="showError"
        submit-btn-label="Zapisz">
        <tabs-item narrow title="Dane kartoteki Pacjenta">
            <form-row>
                <form-inline>
                    <form-input
                        v-model="patient.first_name"
                        label="Imię*"
                        data-vv-as="Imię"
                        v-validate="'required'"
                        speech-to-text>
                    </form-input>
                    <form-input
                        v-model="patient.last_name"
                        label="Nazwisko*"
                        data-vv-as="Nazwisko"
                        v-validate="'required'"
                        speech-to-text>
                    </form-input>
                </form-inline>
            </form-row>
            <form-row>
                <form-input
                    v-model="patient.pesel"
                    label="PESEL*"
                    v-validate="'required|PESEL'"
                    data-vv-as="PESEL"
                    @input="extractDataFromPESEL">
                </form-input>
                <form-date
                    v-model="patient.born_date"
                    format="YYYY-MM-DD"
                    label="Data urodzenia"
                    :max-datetime="nowDate">
                </form-date>
            </form-row>

            <form-row>
                <form-radio-group label="Płeć">
                    <form-radio v-model="patient.gender" native-value="male">Mężczyzna</form-radio>
                    <form-radio v-model="patient.gender" native-value="female">Kobieta</form-radio>
                </form-radio-group>
            </form-row>
        </tabs-item>

        <tabs-item narrow title="Dane kontaktowe Pacjenta">
            <form-row>
                <form-input
                    v-model="patient.address_street"
                    label="Ulica i numer domu"
                    data-vv-as="adres"
                    speech-to-text>
                </form-input>
                <form-inline>
                    <form-input
                        v-model="patient.address_postcode"
                        label="Kod pocztowy"
                        data-vv-as="kod pocztowy"
                        v-validate="'zipcode_pl'">
                    </form-input>
                    <form-input
                        v-model="patient.address_city"
                        label="Miejscowość"
                        data-vv-as="miejscowość"
                        speech-to-text>
                    </form-input>
                </form-inline>
            </form-row>
            <form-row>
                <form-input
                    v-model="patient.phone"
                    label="Numer telefonu"
                    data-vv-as="numer telefonu">
                </form-input>
                <form-input
                    v-model="patient.email"
                    label="Email"
                    data-vv-as="email"
                    v-validate="'email'">
                </form-input>
            </form-row>
        </tabs-item>

        <tabs-item narrow title="Dane przedstawiciela ustawowego">
            <form-row>
                <form-inline>
                    <form-input
                        v-model="patient.contact_person_first_name"
                        data-vv-as="Imię"
                        label="Imię"
                        speech-to-text>
                    </form-input>
                    <form-input
                        v-model="patient.contact_person_last_name"
                        data-vv-as="Nazwisko"
                        label="Nazwisko"
                        speech-to-text>
                    </form-input>
                </form-inline>
            </form-row>

            <form-row>
                <form-input
                    v-model="patient.contact_person_address_street"
                    data-vv-as="Ulica i numer domu"
                    label="Ulica i numer domu"
                    speech-to-text>
                </form-input>
                <form-inline>
                    <form-input
                        v-model="patient.contact_person_address_postcode"
                        label="Kod pocztowy"
                        data-vv-as="kod pocztowy"
                        v-validate="'zipcode_pl'">
                    </form-input>
                    <form-input
                        v-model="patient.contact_person_address_city"
                        data-vv-as="Miejscowość"
                        label="Miejscowość"
                        speech-to-text>
                    </form-input>
                </form-inline>
            </form-row>
            <form-row>
                <form-input
                    v-model="patient.contact_person_phone"
                    data-vv-as="Numer telefonu"
                    label="Numer telefonu">
                </form-input>
                <form-input
                    v-model="patient.contact_person_email"
                    v-validate="'email'"
                    label="Email"
                    data-vv-as="email">
                </form-input>
            </form-row>
        </tabs-item>

        <tabs-item title="Podsumowanie">
            <summary-main>
                <summary-col
                    title="Dane pacjenta"
                    type="50w">
                    <summary-value label="Imię i Nazwisko">{{
                            patient.first_name + ' ' + patient.last_name
                        }}
                    </summary-value>
                    <summary-value label="Data urodzenia">{{ patient.born_date || '&mdash;' }}</summary-value>
                    <summary-value label="Płeć">{{ gender || '&mdash;' }}</summary-value>
                    <summary-value label="PESEL">{{ patient.pesel || '&mdash;' }}</summary-value>
                    <summary-value label="Adres">{{ patient.address_street || '&mdash;' }} <br>
                        {{ patient.address_postcode }} {{ patient.address_city }}
                    </summary-value>
                    <summary-value label="Nr telefonu">{{ patient.phone || '&mdash;' }}</summary-value>
                    <summary-value label="Adres email">{{ patient.email || '&mdash;' }}</summary-value>
                </summary-col>

                <summary-col
                    title="Dane przedstawiciela ustawowego"
                    type="50w">
                    <summary-value label="Imię i Nazwisko">{{ (patient.contact_person_first_name || '&mdash;') }}
                        {{ patient.contact_person_last_name }}
                    </summary-value>
                    <summary-value label="Adres">{{ patient.contact_person_address_street || '&mdash;' }} <br>
                        {{ patient.contact_person_address_postcode }} {{ patient.contact_person_address_city }}
                    </summary-value>
                    <summary-value label="Nr telefonu">{{ patient.contact_person_phone || '&mdash;' }}</summary-value>
                    <summary-value label="Adres email">{{ patient.contact_person_email || '&mdash;' }}</summary-value>
                </summary-col>
            </summary-main>
        </tabs-item>
    </tabs-main>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormInput, FormRow, FormInline, FormDate, FormRadioGroup, FormRadio} from 'Components/Form'
import {SummaryMain, SummaryCol, SummaryValue} from 'Components/Summary'
import {TabsMain, TabsItem} from 'Components/Tabs'
import Pesel from 'Utils/Pesel'
import moment from 'moment'

export default {

    name: 'PatientForm',

    computed: {
        ...mapGetters(['patient']),
        gender() {
            if (this.patient.gender)
                return (this.patient.gender === 'male') ? 'Mężczyzna' : 'Kobieta'
            return null
        },
        nowDate() {
            return moment().format()
        }
    },

    methods: {
        extractDataFromPESEL(val) {
            var pesel = Pesel(val)
            if (pesel.valid) {
                this.patient.gender = pesel.sex
                this.patient.born_date = pesel.date
            }
        },
        checkValid(scope) {
            return this.$validator.validateAll(scope)
        },
        showError() {
            this.$alert.error('Pacjent', 'Popraw błędy w formularzu aby zapisać zmiany.')
        },
        submit(afterCB) {
            this.$emit('submit', afterCB)
        }
    },

    mounted() {
        if (this.patient.born_date)
            this.patient.born_date = this.patient.born_date.split(' ')[0]
    },

    components: {
        TabsMain,
        TabsItem,
        SummaryMain,
        SummaryValue,
        SummaryCol,
        FormInput,
        FormDate,
        FormRow,
        FormInline,
        FormRadioGroup,
        FormRadio,
    }

}

</script>
